export default __webpack_public_path__ + "static/bannerPubli-BO-5ac8ba7064fcd4b8780510187c02145b.png";